import { styled } from '@linaria/react';
import type { HTMLAttributes } from 'react';

const Wrapper = styled.div<{ width?: string; height?: string }>`
  width: ${props => props?.width ?? '100%'};
  height: ${props => props?.height ?? 'auto'};
  margin-bottom: 16px;
  margin-top: 32px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: white;
  border: 1px solid #e2e8f1;
  border-radius: 6px;

  & p {
    font-size: 16px;
    color: #383838;
    font-weight: 500;
  }
`;

const ReloadButton = styled.button`
  background-color: #e03f19;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 10px;
`;

interface ErrorReloadBlockProps {
  width?: string;
  height?: string;
  errorText?: string;
  buttonText?: string;
  onReload?: () => void;
  wrapperProps?: HTMLAttributes<HTMLDivElement>;
  errorTextProps?: HTMLAttributes<HTMLParagraphElement>;
  buttonProps?: HTMLAttributes<HTMLButtonElement>;
}

const ErrorReloadBlock = ({
  width,
  height,
  errorText = '哎呀! 網路出錯了',
  buttonText = '重新載入',
  onReload,
  wrapperProps,
  errorTextProps,
  buttonProps
}: ErrorReloadBlockProps) => {
  return (
    <Wrapper width={width} height={height} {...wrapperProps}>
      <p {...errorTextProps}>{errorText}</p>
      {onReload && (
        <ReloadButton onClick={onReload} {...buttonProps}>
          {buttonText}
        </ReloadButton>
      )}
    </Wrapper>
  );
};

export default ErrorReloadBlock;
